module.exports = __webpack_public_path__ + "img/ctt.cc91e537.png";